import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { combineReducers, applyMiddleware, createStore as createStore$1 } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { jsx } from 'react/jsx-runtime';

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var createStore = (function (reducers, initialState) {
  var middlewares = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var options = _objectSpread$2({}, opts);

  var reducer = combineReducers(reducers);
  var enhancer = applyMiddleware.apply(void 0, _toConsumableArray(middlewares).concat([thunk]));

  if (process.env.NODE_ENV !== 'production') {
    var _options$devTools = options.devTools,
        devTools = _options$devTools === void 0 ? {} : _options$devTools;
    var composeEnhancers = composeWithDevTools(devTools);
    enhancer = composeEnhancers(enhancer);
  }

  return createStore$1(reducer, initialState, enhancer);
});

var _excluded = ["withHost", "paramFormat"];

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var UrlGenerator = /*#__PURE__*/function () {
  function UrlGenerator(routes, opts) {
    _classCallCheck(this, UrlGenerator);

    this.routes = routes;
    this.options = _objectSpread$1({
      paramFormat: ':{key}(\\([^\\)]*\\))?'
    }, opts);
  }

  _createClass(UrlGenerator, [{
    key: "route",
    value: function route(key, opts) {
      var options = _objectSpread$1(_objectSpread$1({
        withHost: false
      }, this.options), opts);

      var withHost = options.withHost,
          paramFormat = options.paramFormat,
          params = _objectWithoutProperties(options, _excluded);

      var route = this.routes[key] || key;
      var url = Object.keys(params).reduce(function (str, k) {
        return str.replace(new RegExp(paramFormat.replace(/\{\s*key\s*\}/gi, k), 'i'), params[k]);
      }, route);
      var host = typeof window !== 'undefined' ? "".concat(window.location.protocol, "//").concat(window.location.host) : '';
      var hostPattern = host !== null ? "^".concat(host) : '^$';

      if (typeof withHost !== 'undefined' && withHost === true) {
        return !url.match(hostPattern) ? "".concat(host).concat(url) : url;
      }

      var urlWithoutHost = url.replace(new RegExp(hostPattern, 'i'), '');
      return urlWithoutHost === '' ? '/' : urlWithoutHost;
    }
  }]);

  return UrlGenerator;
}();

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var UrlGeneratorContext = /*#__PURE__*/React.createContext(null);
/**
 * useUrlGenerator Hook
 */

var useUrlGenerator = function useUrlGenerator() {
  return useContext(UrlGeneratorContext);
};
/**
 * withUrlGenerator HOC
 */

var withUrlGenerator = function withUrlGenerator(WrappedComponent) {
  var getDisplayName = function getDisplayName(_ref) {
    var _ref$displayName = _ref.displayName,
        displayName = _ref$displayName === void 0 ? null : _ref$displayName,
        _ref$name = _ref.name,
        name = _ref$name === void 0 ? null : _ref$name;
    return displayName || name || 'Component';
  };

  var WithUrlGeneratorComponent = function WithUrlGeneratorComponent(props) {
    return /*#__PURE__*/jsx(UrlGeneratorContext.Consumer, {
      children: function children(urlGenerator) {
        return /*#__PURE__*/jsx(WrappedComponent, _objectSpread({
          urlGenerator: urlGenerator
        }, props));
      }
    });
  };

  WithUrlGeneratorComponent.displayName = "WithUrlGenerator(".concat(getDisplayName(WrappedComponent), ")");
  return WithUrlGeneratorComponent;
};
/**
 * UrlGenerator Provider
 */

var propTypes = {
  children: PropTypes.node.isRequired,
  routes: PropTypes.objectOf(PropTypes.string),
  urlGenerator: PropTypes.instanceOf(UrlGenerator)
};
var defaultProps = {
  routes: null,
  urlGenerator: null
};
var UrlGeneratorProvider = function UrlGeneratorProvider(_ref2) {
  var children = _ref2.children,
      routes = _ref2.routes,
      urlGenerator = _ref2.urlGenerator;
  var value = useMemo(function () {
    return urlGenerator !== null ? urlGenerator : new UrlGenerator(routes);
  }, [routes, urlGenerator]);
  return /*#__PURE__*/jsx(UrlGeneratorContext.Provider, {
    value: value,
    children: children
  });
};
UrlGeneratorProvider.propTypes = propTypes;
UrlGeneratorProvider.defaultProps = defaultProps;

export { UrlGenerator, UrlGeneratorContext, UrlGeneratorProvider, createStore, useUrlGenerator, withUrlGenerator };
